export type TableShape = 'round' | 'rectangle'

export type SeatingTable = {
  id: string
  number: string
  label: string
  shape: TableShape
  capacity: number
  x: number
  y: number
  width: number
  height: number
  rotation: number
  /** Hex color override for the table fill (e.g. "#FECACA"). Undefined = default white. */
  color?: string
}

export type EventDetails = {
  name: string
  date: string
  venue: string
}

export const TABLE_COLOR_PALETTE: { value: string | null; label: string; swatch: string }[] = [
  { value: null, label: 'Default', swatch: '#ffffff' },
  { value: '#FECACA', label: 'Rose', swatch: '#FECACA' },
  { value: '#FED7AA', label: 'Orange', swatch: '#FED7AA' },
  { value: '#FEF08A', label: 'Yellow', swatch: '#FEF08A' },
  { value: '#BBF7D0', label: 'Green', swatch: '#BBF7D0' },
  { value: '#BFDBFE', label: 'Blue', swatch: '#BFDBFE' },
  { value: '#DDD6FE', label: 'Purple', swatch: '#DDD6FE' },
  { value: '#FBCFE8', label: 'Pink', swatch: '#FBCFE8' },
  { value: '#E5E7EB', label: 'Gray', swatch: '#E5E7EB' },
]

export type SeatingGuest = {
  id: string
  name: string
  notes?: string
}

export type SeatingViewSettings = {
  detailedTables: boolean
}

export type SeatAssignment = {
  tableId: string
  seatIndex: number
}

export type PlanState = {
  version: 1
  view: SeatingViewSettings
  tables: SeatingTable[]
  guests: SeatingGuest[]
  /** guestId -> { tableId, seatIndex }. Missing = unassigned. */
  assignments: Record<string, SeatAssignment>
  event: EventDetails
  /** Maximum number of tables allowed. 0 = no limit. */
  tableLimit: number
}

export const DEFAULT_EVENT_DETAILS: EventDetails = { name: '', date: '', venue: '' }

export const DEFAULT_PLAN_STATE: PlanState = {
  version: 1,
  view: { detailedTables: false },
  tables: [],
  guests: [],
  assignments: {},
  event: { ...DEFAULT_EVENT_DETAILS },
  tableLimit: 0,
}
